<script setup>
import Header from '@/components/layout/Header.vue'
import Navbar from '@/components/layout/Navbar.vue'
import Sidebar from '@/components/base/Sidebar.vue'
import ContainerFluid from '@/components/base/ContainerFluid.vue'
import ManagementLinks from "@/components/sidebar-links/ManagementLinks.vue";
import TransactionsLinks from "@/components/sidebar-links/TransactionsLinks.vue";
import MonitoringLinks from "@/components/sidebar-links/MonitoringLinks.vue";
import ReportsLinks from "@/components/sidebar-links/ReportsLinks.vue";
import SetupLinks from "@/components/sidebar-links/SetupLinks.vue";
import EntityLinks from "@/components/sidebar-links/EntityLinks.vue";
import {useCollapsibleStore} from "@/stores/useCollapsibleStore";
// when dynamically getting logo, change url or get from db
import Image from '@/assets/ftlp-logo-1.png'
import DashboardLinks from "@/components/sidebar-links/DashboardLinks.vue";
import {sidebarSublinkCollapse} from "@/stores/subSidebarLinkCollapse";
import {computed, onMounted, ref} from "vue";
import {useModuleStatesStore} from "@/stores/useModuleStatesStore";
import {useRoute} from "vue-router";

const route = useRoute()
const collapsibleState = useCollapsibleStore()
const moduleState = useModuleStatesStore()
const currentRouteName = computed(() => {
  return route.name
})
const branchLiquidationLinks = ['branchLiquidationList', 'newBranchLiquidation', 'branchLiquidationDetails']

sidebarSublinkCollapse()
onMounted(async () => {
  let user = JSON.parse(localStorage.getItem('authUser'))
  let headers = localStorage.getItem('header')
  let modules = localStorage.getItem('submodules')
  moduleState.user_permissions.header = JSON.parse(headers)
  moduleState.user_permissions.submodules = JSON.parse(modules)
  await moduleState.getPermissions(user['user_name'])
})
</script>

<template>
  <div id="dashboard">
    <header id="master-header" class="sticky-top">
        <Header :logo="Image"/>
        <Navbar />
    </header>

    <ContainerFluid>
      <template #containerContent>
        <div class="row g-0">

          <div class="left-main-view z-3" :class="collapsibleState.isSidebarCollapsed || branchLiquidationLinks.includes(currentRouteName) ? 'collapse-container' : ''">
            <Sidebar #sidebarContent :class="[ collapsibleState.isSidebarCollapsed ? 'sidebarOpened' : '' ]" v-if="!branchLiquidationLinks.includes(currentRouteName)">
              <!--On setting the content of the sidebar based on the active route,
                  check if the container of parent route is or has child that is the active route.
                  The hiding of non-active routes is done through css
              -->
              <DashboardLinks />
              <TransactionsLinks v-if="moduleState.user_permissions.header.includes('transactions')"/>
              <ManagementLinks v-if="moduleState.user_permissions.header.includes('monitoring')"/>
              <ReportsLinks v-if="moduleState.user_permissions.header.includes('reports')"/>
              <MonitoringLinks v-if="moduleState.user_permissions.header.includes('management')"/>
              <SetupLinks v-if="moduleState.user_permissions.header.includes('setup')"/>
              <EntityLinks v-if="moduleState.user_permissions.header.includes('entities')"/>
            </Sidebar>
          </div>
          <div class="right-main-view">
            <RouterView class="px-2 pt-3"/>
          </div>
        </div>
      </template>
    </ContainerFluid>
  </div>
</template>

<style scoped>

</style>